let config = ($httpProvider, $locationProvider, $mdIconProvider) => {
	$httpProvider.interceptors.push('HttpInterceptor');
	// @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
	// #how-to-configure-your-server-to-work-with-html5mode
	$locationProvider.html5Mode(true).hashPrefix('!');
	$mdIconProvider.fontSet('material-design-icons', 'mdi');
	moment.locale('pt');
}

config.$inject = ['$httpProvider', '$locationProvider', '$mdIconProvider'];

export default config;


// WEBPACK FOOTER //
// ./client/app/config/config.js